import { MessageCircle, LifeBuoy } from "lucide-react";
import { cn } from "@/lib/utils";
import { buildWhatsAppSupportUrl, buildSupportTicketUrl } from "@/lib/supportLinks";

interface ErrorSupportLinksProps {
  /** Exact error text, included in the prefilled WhatsApp message */
  errorText?: string;
  /** Optional error category, e.g. "Pago", "Carga de imagen" */
  errorType?: string;
  variant?: "inline" | "block";
  className?: string;
}

/**
 * Small support affordance shown alongside error messages:
 * WhatsApp + create a support ticket.
 */
export function ErrorSupportLinks({
  errorText,
  errorType,
  variant = "inline",
  className,
}: ErrorSupportLinksProps) {
  const wa = buildWhatsAppSupportUrl(errorText, { errorType });
  const ticketUrl = buildSupportTicketUrl(errorText, { errorType });


  const linkClass =
    "inline-flex items-center gap-1 underline underline-offset-2 hover:opacity-80 transition-opacity";

  return (
    <div
      className={cn(
        "flex flex-wrap items-center gap-x-3 gap-y-1 text-xs",
        variant === "block" ? "mt-4 text-muted-foreground" : "mt-1.5 opacity-90",
        className
      )}
    >
      <span className="opacity-80">
        {variant === "block" ? "\u00bfSeguís con problemas?" : "\u00bfNecesitás ayuda?"}
      </span>
      <a className={linkClass} href={wa} target="_blank" rel="noopener noreferrer">
        <MessageCircle className="h-3.5 w-3.5" />
        WhatsApp
      </a>
      <a className={linkClass} href={ticketUrl}>
        <LifeBuoy className="h-3.5 w-3.5" />
        Crear ticket
      </a>
    </div>
  );
}

export default ErrorSupportLinks;
